// 这个方法不会区分是富途牛牛App还是美分moomoo APP,富途牛牛和mooomoo都会判断为true
const { plugins: { weblib } } = require('@futuweb/fego-render');
const { isMobileNN } = weblib['@futuweb/tool-browser'];

const isMobileNNApp = isMobileNN();
const isMoo = location.host.indexOf('moomoo.com') > -1;

const LANG_SC = 0;
const LANG_TC = 1;
const LANG_EN = 2;
const LANG_JA = 5;

const LANG_LIST = {
    [LANG_SC]: 'zh-cn',
    [LANG_TC]: 'zh-hk',
    [LANG_EN]: 'en-us',
    [LANG_JA]: 'ja'
};

const LANG_NUM_STRING_MAP = {
    [LANG_SC]: 'stringSc',
    [LANG_TC]: 'stringTc',
    [LANG_EN]: 'stringEn',
    [LANG_JA]: 'stringJa'
};

const FEED_TYPE = {
    TEXT: 0,
    TEXT_LINK: 7,
    STOCK: 3
};

const CONTENT_TYPE = { // 对应后端枚举
    NEWEST: 1,
    HOT: 3,
    // 自定义feed枚举
    CUSTOM: 99
};

const isNewFeedListType = (type) => {
    return type === CONTENT_TYPE.NEWEST;
};

const isHotFeedListType = (type) => {
    return type === CONTENT_TYPE.HOT;
};

const isCustomFeedListType = (type) => {
    return type === CONTENT_TYPE.CUSTOM;
};

const MIN_FEED_ID = 62040047616001;

export default {
    THEME: {
        BLACK: 'black',
        WHITE: 'white'
    },
    CONTENT_TYPE,
    LANG: {
        LANG_SC,
        LANG_TC,
        LANG_EN,
        LANG_JA
    },
    LANG_LIST,
    LANG_NUM_STRING_MAP,
    FEED_TYPE,
    isNewFeedListType,
    isHotFeedListType,
    isCustomFeedListType,
    isMobileNN: isMobileNNApp,
    isMoo,
    MIN_FEED_ID
};
